export async function getCNAMEFromDomain(domain) {
    try {
        const response = await fetch(`https://cloudflare-dns.com/dns-query?name=${domain}&type=CNAME`, {
            headers: {
                Accept: 'application/dns-json',
            },
        });

        if (!response.ok) return null;

        const data = await response.json();

        if (!data.Answer) return null;

        const cnameRecord = data.Answer.find(record => record.type === 5);

        if (!cnameRecord) return null;

        return cnameRecord.data.endsWith('branded-domains.singular.net.') ? cnameRecord.data.slice(0, -1) : null;
    } catch (error) {
        console.error(`Error checking CNAME for ${domain}: ${error.message}`);
        return null;
    }
}
